module.exports = __webpack_public_path__ + "static/media/stacked-line-chart.fc897c9a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/stacked-line-chart.svg
// module id = ./src/assets/icons/stacked-line-chart.svg
// module chunks = 0